import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { getClientDisplayName, getClientInitials } from "../utils/clientDetailsHelpers";

const pill = (label, bg, fg) => (
  <span
    className="rounded-2"
    style={{
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: 0.5,
      textTransform: "uppercase",
      background: bg,
      color: fg,
      padding: "4px 9px",
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </span>
);

const ClientDetailHeader = ({ clientInfo, isNaturalClient, isViewer, onEdit, onNewContract }) => {
  const displayName = getClientDisplayName(clientInfo);
  const initials = getClientInitials(clientInfo);
  const email = isNaturalClient
    ? clientInfo?.personal_email
    : clientInfo?.business_email || clientInfo?.personal_email;
  const since = clientInfo?.created_at ? moment(clientInfo.created_at).format("MMM YYYY") : null;

  return (
    <>
      <div className="d-flex align-items-center gap-2 text-muted mb-3" style={{ fontSize: 12.5 }}>
        <Link to="/financial/clients">Clients</Link>
        <span>/</span>
        <span className="text-body">{displayName || "—"}</span>
      </div>

      <div className="d-flex align-items-start gap-3 flex-wrap mb-4">
        <div
          className="rounded-4 d-flex align-items-center justify-content-center flex-shrink-0"
          style={{ width: 56, height: 56, background: "#1b1b21", color: "#fff", fontSize: 19, fontWeight: 600 }}
        >
          {initials}
        </div>

        <div className="flex-grow-1" style={{ minWidth: 280 }}>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h1 className="mb-0" style={{ fontSize: 27, fontWeight: 650, letterSpacing: -0.5 }}>
              {displayName || "Unnamed client"}
            </h1>
            {isNaturalClient
              ? pill("Individual", "#eceafd", "#4338ca")
              : pill("Company", "#e8f1fb", "#1c5b8f")}
            {clientInfo?.active
              ? pill("Active", "#e6f4ec", "#146c43")
              : pill("Inactive", "#f2f2f6", "#767683")}
          </div>
          <div className="d-flex gap-3 flex-wrap mt-1 text-muted" style={{ fontSize: 13.5 }}>
            {email && <span>{email}</span>}
            {clientInfo?.mobile_phone_number && <span>{clientInfo.mobile_phone_number}</span>}
            {since && <span>Client since {since}</span>}
          </div>
        </div>

        {!isViewer && (
          <div className="d-flex gap-2 flex-shrink-0">
            <Button color="light" onClick={onEdit}>
              Edit client
            </Button>
            <Button color="primary" onClick={onNewContract}>
              + New contract
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

ClientDetailHeader.propTypes = {
  clientInfo: PropTypes.object,
  isNaturalClient: PropTypes.bool,
  isViewer: PropTypes.bool,
  onEdit: PropTypes.func,
  onNewContract: PropTypes.func,
};

export default ClientDetailHeader;
